import I18n from 'I18n';
import { createSelector } from 'reselect';
import { getCurrentUserAttributes } from './EntitySelector';
export const getCurrentUserPhoneNumber = createSelector([getCurrentUserAttributes], attributes => attributes.get('phoneNumber'));
export const getCurrentUserDefaultPhoneCountryCode = createSelector([getCurrentUserAttributes], attributes => attributes.get('defaultPhoneCountryCode'));
export const getCurrentUserLocale = createSelector([getCurrentUserAttributes], attributes => {
  return attributes.get('languageAndLocale') !== undefined ? attributes.get('languageAndLocale').get('locale') : undefined;
});
export const getCurrentUserLanguage = createSelector([getCurrentUserAttributes], attributes => {
  return attributes.get('languageAndLocale') !== undefined ? attributes.get('languageAndLocale').get('language') : undefined;
});
export const getLocaleNumberSample = createSelector([getCurrentUserLocale], locale => I18n.formatNumber(1234.56, I18n.lookup('number.format', {
  locale
})));
function getLocaleDateWithFormat(momentFormat) {
  return () => {
    return I18n.moment().format(momentFormat);
  };
}
export const getLocaleDateSample = createSelector([getCurrentUserLocale], getLocaleDateWithFormat('L'));
export const getLocaleLongFormDateSample = createSelector([getCurrentUserLocale], getLocaleDateWithFormat('LL'));
export const getUnsubscribeLinkType = createSelector([getCurrentUserAttributes], attributes => attributes.get('unsubscribeLinkType'));
export const getCurrentUserDefaultHome = createSelector([getCurrentUserAttributes], attributes => attributes.get('defaultHome'));